import { Autor } from "@/v2/types/autor";
import { Imagem } from "@/v2/types/imagem";
import Head from "next/head";

export interface MetatagsProps {
  titulo: string;
  descricao: string;
  canonical?: string;
  ogURL?: string;
  autor?: Autor;
  imagem?: Imagem;
  robots: {
    index?: boolean;
    follow?: boolean;
    maxImagePreview?: "none" | "large";
  };
}

function robotsToString(robots: MetatagsProps["robots"]): string|null {
  let result = [];

  robots.index === undefined && (robots.index = true);

  if (!robots.index) {
    result.push("noindex");

    if (robots.follow === undefined) {
      robots.follow = false;
    }
  }

  if (!robots.follow) {
    result.push("nofollow");
  }

  if (robots.maxImagePreview) {
    result.push(`max-image-preview:${robots.maxImagePreview}`);
  }

  return result.join(", ") || null;
}

export function Metatags({ titulo, descricao, ...dados }: MetatagsProps) {
  const autor = dados.autor || {
    nome: "Canaltech",
    twitter: "@canaltech",
  };

  const robots = robotsToString(dados.robots);

  const imagem = dados.imagem || {
    url: "https://img.canaltech.com.br/canaltech-512.png",
    largura: 512,
    altura: 512,
  };

  return (
    <Head>
      <title>{titulo}</title>
      <meta property="og:title" content={titulo} />
      <meta name="description" content={descricao} />
      <meta property="og:description" content={descricao} />
      <meta name="twitter:title" content={titulo} />
      <meta name="twitter:description" content={descricao} />

      <meta name="author" content={autor.nome} />
      <meta name="twitter:creator" content={autor.twitter} />

      {dados.canonical && <link rel="canonical" href={dados.canonical} />}
      {dados.ogURL && <meta property="og:url" content={dados.ogURL} />}

      {robots && <meta name="robots" content={robots} />}

      <meta name="image" content={imagem.url} />
      <meta property="og:image" content={imagem.url} />
      <meta property="og:image:height" content={imagem.altura.toString()} />
      <meta property="og:image:width" content={imagem.largura.toString()} />
      <meta name="twitter:image" content={imagem.url} />
      <meta name="twitter:card" content={dados.imagem ? "summary_large_image" : "summary"} />
    </Head>
  );
}
